import { Box, TextField, Typography, IconButton } from '@mui/material';

import { AutoAwesome as SparkleIcon, ArrowForward as ArrowIcon } from '@mui/icons-material';
import { Control, Controller } from 'react-hook-form';
import useProductsProvider from '../../../layouts/MainLayout/hooks/useProductsProvider';

interface FixedFooterProps {
  disabled?: boolean;
  onSubmit: (data: any) => void;
  control: Control<any>;
  isDirty: boolean;
}

export default function FixedFooter({ disabled, onSubmit, control, isDirty }: FixedFooterProps) {
  const FOOTER_HEIGHT = 120;
  const { productBasedChatPlaceholder, currentProduct } = useProductsProvider();
  return (
    <Box
      sx={{
        minheight: FOOTER_HEIGHT,
        backgroundColor: 'background.default',
        borderTop: '1px solid',
        borderColor: 'grey.300',
        px: 2,
        py: 1.5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '0 auto',
        width: '100%',
      }}
    >
      <form onSubmit={onSubmit} style={{ width: '100%', maxWidth: '900px', margin: '0 auto' }}>
        <Box sx={{ width: '100%', mb: 1.25 }}>
          <Controller
            control={control}
            name="message"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                placeholder={productBasedChatPlaceholder[currentProduct]}
                variant="outlined"
                error={!!error}
                disabled={disabled}
                // helperText={error?.message}
                InputProps={{
                  startAdornment: (
                    <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                      <SparkleIcon sx={{ color: 'primary.main', fontSize: 18 }} />
                    </Box>
                  ),
                  endAdornment: (
                    <IconButton
                      disabled={!isDirty || disabled}
                      type="submit"
                      sx={{
                        backgroundColor: 'primary.main',
                        color: 'white',
                        width: 40,
                        height: 40,
                        ml: 0.5,
                        mr: 0.5,
                        '&:hover': {
                          backgroundColor: 'primary.dark',
                        },
                      }}
                    >
                      <ArrowIcon />
                    </IconButton>
                  ),
                }}
              />
            )}
          />
        </Box>
      </form>

      {/* Footer */}
      <Typography
        variant="caption"
        sx={{
          textAlign: 'center',
          display: 'block',
        }}
      >
        AITiger can be inaccurate. Please verify all information before making any decisions.
      </Typography>
    </Box>
  );
}
